import { ResponsiveValue } from '@chakra-ui/react';
import { CartItem } from '../Analytics';

export interface OverlayProps {
  collectibletToastActive: boolean;
  wishlistToastActive: boolean;
  wishlistToastText: string;
  collectedItems: { giftcard: boolean; ribbon: boolean; giftbox: boolean };
  activeScene: string;
  audioActive: boolean;
  activeLocale: string;
  setLocale: (locale: string) => void;
  closeAllUI: () => void;
  toggleInstructions: () => void;
  toggleAudio: () => void;
  setActiveScene: (scene: string) => void;
  setCollectibletToastActive: (state: boolean) => void;
  setWishlistToastActive: (state: boolean) => void;
  openWishlist: () => void;
  openReward: () => void;
}

type Position = 'absolute' | 'unset';
export interface ToastProps {
  activeLocale: string;
  position: ResponsiveValue<Position> | undefined;
  active: boolean;
  text: string;
  setActive: (state: boolean) => void;
}

export interface WishlistProps {
  wishlistProducts: WishlistItemProps[];
  activeLocale: string;
  active: boolean;
  setActive: (state: boolean) => void;
  removeFromWishlist: (productId: string) => void;
}

export interface OutOfStockProps {
  activeLocale: string;
  active: boolean;
  setActive: (state: boolean) => void;
}
export interface DrawerItemProps {
  scene: string;
  heading: string;
  subHeading: string;
  handler: () => void;
}
export interface DrawerMenuItemProps {
  active: boolean;
  heading: string;
  subHeading: string;
}
export interface LoadingProps {
  setLoadUI: () => void;
}

export interface MockLoadingProps {
  videoUrl: string;
  setLoadUI: () => void;
}
export interface WelcomeProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface SubscribeProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}
export interface InstructionsProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface CompletedProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface SubscribeProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface RewardInfoProps {
  leftItems: number;
  collectedItems: { giftcard: boolean; ribbon: boolean; giftbox: boolean };
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface WhatToBringProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface RetroHolidayProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface ChristmasPickProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface ArtOfGiftProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface PostCardSentProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface AddedToCartProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface RefillFountainProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface TransitionalVideoProps {
  videoURL: string;
  room: string;
  playing: boolean;
  setPlaying: () => void;
}

export interface ImageSliderProps {
  activeLocale: string;
  highlightImage: string;
  images: string[];
  setHighLightImage: (image: string) => void;
}
export interface SizeProps {
  size: string;
  selectedSize: string;
  setSelectedSize: (size: string) => void;
}

export interface ColorProps {
  color: string;
  selectedColor: string;
  setSelectedColor: (size: string) => void;
}

export interface PostCardProps {
  wishlistProducts: WishlistItemProps[];
  activeLocale: string;
  active: boolean;
  setActive: () => void;
  removeFromWishlist: (productId: string) => void;
}

export interface PostCardMobileProps {
  wishlistProducts: WishlistItemProps[];
  activeLocale: string;
  active: boolean;
  setActive: () => void;
  removeFromWishlist: (productId: string) => void;
}
export interface TransitionalVideo {
  videoURL: string;
  active: boolean;
  gotoRoom: string;
}
export interface AudioToggleModalProps {
  activeLocale: string;
  active: boolean;
  proceedAudio: (state: boolean) => void;
}
export interface ARViewModalProps {
  active: boolean;
  setActive: () => void;
}
export interface PDPProps {
  setToastActive: (text: string) => void;
  activeLocale: string;
  pdpData?: ProductData;
  active: boolean;
  productMetaData: ProductMetaData;
  setActive: (state: boolean) => void;
  addToWishlist: (wishlistProduct: WishlistItemProps) => void;
}

export interface GeneralImagePopUpProps {
  url: string;
  active: boolean;
  setActive: (state: boolean) => void;
}

export interface AudioLayerProps {
  playAudio: boolean;
}
export interface RoomItemProps {
  activeLocale: string;
  alignRight: boolean;
  rightIcon?: boolean;
  divider?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any;
  itemText: string;
  onClick?: () => void;
}

export interface WishlistProductProps {
  width?: string[];
  activeLocale: string;
  productImage: string;
  productName: string;
  productMetric: string;
  productPrice: string;
  productCurrency: string;
  removeFromWishlist: () => void;
}

export interface ChooseTextProps {
  activeLocale: string;
  bgColor: string;
  chosen: boolean;
  content: string;
  setActive: () => void;
}

export interface ChoosePatternProps {
  activeLocale: string;
  bgColor: string;
  chosen: boolean;
  setActive: () => void;
}

export interface ProductData {
  id: string;
  collection: string;
  product_sku: string;
  title: string;
  description: string;
  short_description: string;
  category: string;
  currency: string;
  default_url: string;
  base_price: string;
  variants_selection_order: string[];
  variants: ProductVariant[];
}

export interface ProductMetaData {
  organisationName: string | null;
  experienceName: string | null;
  roomName: string;
  browser: string;
  os: string;
}

export interface ProductVariant {
  default: boolean;
  variant_id: string;
  variant_sku: string;
  variants: { variant_type: string; value: string }[];
  available_stock: number;
  media: ProductMedia[];
  momenti_url: string;
  retail_price: string;
  sale_price: string;
  availability: string;
}

export interface ProductMedia {
  url: string;
  main: ConstrainBoolean;
  thumbnail_url: string;
  media_type: string;
  mobile_version_url: string;
}

export interface WishlistItemProps {
  product_id: string;
  product: CartItem;
  image: string;
  size: string;
  title: string;
  price: string;
  currency: string;
}

export const EmptyProductData = {
  id: '',
  collection: '',
  product_sku: '',
  title: '',
  description: '',
  short_description: '',
  category: '',
  currency: '',
  default_url: '',
  base_price: '',
  variants_selection_order: [],
  variants: [],
};
